/*
 * @Description: 智兔App 对接沙滩说 兔学堂和学习任务 列表
 * @Author: gaolei
 * @Date: 2025-09-01
 * @LastEditTime: 2025-09-01
 * @LastEditors: gaolei
 */

import { useAuthStore } from '@/stores/login'
import { loading } from '@/utils/loading'
// import { showToast } from 'vant'
import { useUsersStore } from '@/stores/users'
import router from '@/router'

export const isWisdomRabbitApp = window.navigator.userAgent.indexOf('cn_rabbit_app') > -1

function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const invokeMethod = async (name: string, params: string): Promise<any> => {
  try {
    // console.log('invokeMethod called with name:', params);
    if (window.flutter_inappwebview) {
      // console.log('window.flutter_inappwebview is available');
      if (typeof window.flutter_inappwebview.callHandler === 'function') {
        // console.log('window.flutter_inappwebview.callHandler is a function');
        return await window.flutter_inappwebview.callHandler(name, params)
      } else {
        await sleep(200)
        return window.flutter_inappwebview.callHandler(name, params)
      }
    } else {
      // console.error('window.flutter_inappwebview is not available');
      setTimeout(() => {
        window.location.replace(location.href)
      }, 200)
      return ''
    }
  } catch (error) {
    console.error('Error in invokeMethod:', error);
    return ''
  }
}


export const wisdomRabbitLogin = async () => {
  loading.show()
  const res = await invokeMethod('flutterBridge', 'getToken')
  loading.hide()

  if (!res) {
    return {}
  }
  const authStore = useAuthStore()
  const usersStore = useUsersStore()
  const { setCollegeId } = usersStore
  const data = res.data

  console.log('智兔data', data);

  const { stanToken: token, tenantId, collegeId, language } = data

  console.log('智兔学院collegeId', collegeId);
  localStorage.setItem('sandsTalkToken', token)
  localStorage.setItem('sandsTalkTenantId', tenantId || '1000')
  localStorage.setItem('lang', language || 'id')
  authStore.setAccessToken(token)
  setCollegeId(collegeId)
  router.replace('/')
  return token
}

export const wisdomRabbitSetTitle = (str: string) => {
  window.flutter_inappwebview.callHandler('flutterSetTitleName', str)
}

export const wisdomRabbitSetHoriVerti = (isFull: boolean) => {
  window.flutter_inappwebview.callHandler('flutterSetHoriVerti', isFull)
}

export const wisdomRabbitDownloadH5Url = (url: string) => {
  window.flutter_inappwebview.callHandler('flutterDownloadH5Url', url)
}


export const wisdomRabbitGoToNativeLoadUrl = (url: string) => {
  window.flutter_inappwebview.callHandler('flutterLoadUrl', url)
}

export const wisdomRabbitCloseWebview = () => {
  window.flutter_inappwebview.callHandler('flutterH5LoginOutFrmHome', '')
}

export const tudoGetLang = async () => {
  // 改为从 UA 中获取语言
  return getLangFromUA()
}

// 从 UA 中解析多语言（如 lang=zh-CN、language=en-US、locale=zh_CN，或自定义嵌入在 app UA 中）
// 失败时回退到 navigator.language，最终统一成小写短横线格式：zh-cn / en-us
const getLangFromUA = (): string => {
  const ua = window.navigator.userAgent || ''
  const candidates: Array<RegExp> = [
    // lang=xx-XX / language=xx-XX / locale=xx-XX / 也兼容空格、冒号、斜杠
    /(?:^|[;()\s])(?:lang(?:uage)?|locale)[=/: ]\s*([a-zA-Z]{2}(?:[-_][a-zA-Z]{2})?)/i,
    // 兼容可能写在 cn_rabbit_app 后的语言标识（例如 cn_rabbit_app/zh-CN 或 cn_rabbit_app_zh-CN）
    /cn_rabbit_app[^\w]?([a-zA-Z]{2}(?:[-_][a-zA-Z]{2})?)/i,
    // 通用兜底：捕获形如 en-US 的片段
    /(^|[^\w])([a-zA-Z]{2}-[a-zA-Z]{2})([^\w]|$)/,
  ]

  for (const re of candidates) {
    const m = ua.match(re)
    const raw = (m && (m[2] || m[1])) || ''
    if (raw) {
      return normalizeLang(raw)
    }
  }

  // 回退到浏览器首选语言
  return normalizeLang(window.navigator.language || 'zh-CN')
}

const normalizeLang = (lang: string): string => {
  let l = (lang || '').toLowerCase().replace('_', '-')
  // 常见最简写规范化
  if (l === 'zh') l = 'zh-cn'
  if (l === 'en') l = 'en-us'
  return l
}

